export default __webpack_public_path__ + "static/media/eye-open.371c3195.svg";